import React from "react";
import injectSheet from "react-jss";
import { IconPlus, FormFieldset, FormLegend, Spacing } from "folksam-ui";
import { useTranslation } from "react-i18next";
import ArrayFieldItemTemplate from "../ArrayFieldItemTemplate";
import ItemList from "components/ItemList";

const style = ({ theme }) => ({
  root: {
    padding: 0
  },
  button: {
    cursor: "pointer",
    display: "flex",
    backgroundColor: "transparent",
    alignItems: "center",
    border: "none",
    color: "#257886",
    fontFamily: theme.fonts.serif,
    fontSize: theme.textSizes.base,
    fontWeight: theme.fontWeights.semibold,
    "&:hover, &:hover $icon": {
      fill: "#31a3ae",
      color: "#31a3ae"
    }
  },
  icon: {
    fill: theme.colors.white,
    marginRight: theme.margin["2"],
    lineHeight: 0,
    borderRadius: "50%",
    backgroundColor: "#257886",
    border: "2px solid #257886"
  }
});

const ArrayFieldTemplate = ({
  title: titleFromSchema,
  DescriptionField,
  description,
  items,
  canAdd,
  onAddClick,
  uiSchema,
  classes
}) => {
  const { t } = useTranslation();
  const title = uiSchema["ui:title"] || titleFromSchema;
  const itemHeading =
    uiSchema["ui:options"] && uiSchema["ui:options"][["itemHeading"]];
  const showItemEdit = items.length > 1;

  return (
    <FormFieldset>
      {title ? <FormLegend>{title}</FormLegend> : null}

      {description ? <DescriptionField description={description} /> : null}

      {items ? (
        <ItemList active={`${itemHeading}-${items.length - 1}`}>
          {items.map((element, index) => (
            <ArrayFieldItemTemplate
              {...element}
              heading={itemHeading}
              key={index}
              showEdit={showItemEdit}
            />
          ))}
        </ItemList>
      ) : null}

      {canAdd ? (
        <Spacing y="sm">
          {/** FolksamUI component? */}
          <button className={classes.button} onClick={onAddClick} type="button">
            <IconPlus className={classes.icon} width={16} height={16} />{" "}
            {t("list.add.label")}
          </button>
        </Spacing>
      ) : null}
    </FormFieldset>
  );
};

export default injectSheet(style)(ArrayFieldTemplate);
